var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TippyComponent,{staticClass:"overflow-hidden ml-1 cursor-pointer",attrs:{"popper-options":{
        strategy: 'fixed',
        modifiers: [
            {
                name: 'flip',
                options: {
                    fallbackPlacements: ['bottom', 'right']
                }
            }
        ]
    }},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('div',{staticClass:"preset-thumbnail",class:{
                disabled: _vm.disabled
            },on:{"click":_setup.handleClick}},[_c('div',{staticClass:"thumbnail-container"},[_c(_setup.CLazy,[(_vm.preset.thumbnail)?_c('img',{staticClass:"thumbnail-image",attrs:{"src":_vm.preset.thumbnail,"alt":_vm.preset.label,"lazy":""}}):_c('img',{staticClass:"thumbnail-image",attrs:{"src":require('@/angular-app/images/placeholderCustomily.png'),"alt":_vm.preset.label,"lazy":""}})])],1),_vm._v(" "),_c('div',{staticClass:"preset-label"},[_vm._v(_vm._s(_vm.preset.label))])])]},proxy:true}])},[_vm._v(" "),_c(_setup.BodyPresetGridThumbnailHover,{attrs:{"preset":_vm.preset}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }